module.exports = __webpack_public_path__ + "img/Mb_Exhibition_Logo.86e31ac4.jpg";